// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/" + (chunkId === 96 ? "vendors" : chunkId) + "." + {"96":"a516d690dab832b18798","785":"88afe9ed3bf28deccd85"}[chunkId] + ".js";
};